import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=4a5354c9&scoped=true&"
import script from "./signature.vue?vue&type=script&lang=ts&"
export * from "./signature.vue?vue&type=script&lang=ts&"
import style0 from "./signature.vue?vue&type=style&index=0&id=4a5354c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5354c9",
  null
  
)

export default component.exports